var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 50,
    viewBox: "0 0 34 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_123_443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33456 50C12.9346 50 16.6679 46.2667 16.6679 41.6667V33.3334H8.33456C3.73455 33.3334 0.0012207 37.0667 0.0012207 41.6667C0.0012207 46.2667 3.73455 50 8.33456 50Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0012207 25C0.0012207 20.4 3.73455 16.6666 8.33456 16.6666H16.6679V33.3333H8.33456C3.73455 33.3333 0.0012207 29.6 0.0012207 25Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00170898 8.33333C0.00170898 3.73333 3.73504 0 8.33504 0H16.6684V16.6667H8.33504C3.73504 16.6667 0.00170898 12.9333 0.00170898 8.33333Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6678 0H25.0012C29.6012 0 33.3345 3.73333 33.3345 8.33333C33.3345 12.9333 29.6012 16.6667 25.0012 16.6667H16.6678V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3345 25C33.3345 29.6 29.6012 33.3333 25.0012 33.3333C20.4012 33.3333 16.6678 29.6 16.6678 25C16.6678 20.4 20.4012 16.6666 25.0012 16.6666C29.6012 16.6666 33.3345 20.4 33.3345 25Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3357,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.57d8c448eb7842ddebcfe53d844a25ce.svg";
export { ForwardRef as ReactComponent };